export const getActivityColor = (activityPct, hex = false) => {
  if (activityPct >= 80) {
    return hex ? '#0eb01d' : 'green';
  } else if (activityPct < 80 && activityPct >= 61) {
    return hex ? '#adcfff' : 'blue';
  } else if (activityPct < 60 && activityPct >= 51) {
    return hex ? '#f8d8ab' : 'yellow';
  } else if (activityPct <= 50) {
    return hex ? '#ff383c' : 'red';
  }
};
